import { Component, computed, input } from '@angular/core';
import { EventCategory } from 'in-time-core';
import { getRouteForEventCategory } from '../../utility/route-utils';
import { getLocalizationKeyForEventCategory } from '../../utility/localization-utils';
import { SelectableTextTheme } from '../../../../ui/components/selectable-text/selectable-text.component';

@Component({
  selector: 'app-event-category-selector',
  templateUrl: './event-category-selector.component.html',
})
export class EventCategorySelectorComponent {
  public readonly category = input.required<EventCategory>();
  public readonly isSelected = input.required<boolean>();
  public readonly theme = input.required<SelectableTextTheme>();

  public readonly categoryLocalizationKey = computed(() => {
    return getLocalizationKeyForEventCategory(this.category());
  });

  public readonly route = computed(() => {
    const isSelected = this.isSelected();
    if(isSelected) {
      return '/';
    }

    return getRouteForEventCategory(this.category());
  });
}
